const conFig = {
  //backend: "http://10.53.67.9:99",
  //backend: "http://10.53.67.9:59584",
  keymap: "c5d5b5265e0c4f5185682ab6f07bf608",
  backend: "https://api-qlvt.vnptgialai.vn",
  link: "https://api-qlvt.vnptgialai.vn/api/QLVanBan/DownloadFile?fileId=",
};

export default conFig;
